import React from 'react';

import { FeatureFlagContext } from '../../../context/featureFlagContext';
import { CompactStoreActionCategory } from './storeActionDomain';
import {
  COMPACT_STORE_ACTION_CATEGORY_ORDER,
  CompactStoreActionCategoryCounts,
} from './storeActionFilters';

export const useStoreActionCategoryFilter = (
  category: CompactStoreActionCategory,
  onCategoryChange: (category: CompactStoreActionCategory) => void,
  counts: CompactStoreActionCategoryCounts | null
) => {
  const { MXStoreIdentifier } = React.useContext(FeatureFlagContext);
  const categories = COMPACT_STORE_ACTION_CATEGORY_ORDER.filter(
    (bucket) =>
      (bucket !== 'FACTPAY' || Number(MXStoreIdentifier) === 1) &&
      (bucket !== 'OTHER' || (counts !== null && counts.OTHER !== 0))
  );
  const selectedCategory = categories.includes(category) ? category : 'ALL';

  React.useEffect(() => {
    if (selectedCategory !== category) {
      onCategoryChange(selectedCategory);
    }
  }, [category, onCategoryChange, selectedCategory]);

  return { categories, selectedCategory };
};
